import axios from "axios";
import { getCookie } from "./utils";
let host = window.location.host;
let BaseUrl;
if (host === "apps.cochat.lenovo.com") {
  BaseUrl = "https://admin.cochat.lenovo.com/api";
} else if (host === "webtest.cochat.lenovo.com") {
  BaseUrl = "https://uat.cochat.lenovo.com/admin-cochat/api";
} else if (host.includes("akamai")) {
  BaseUrl = "https://admin.cochat.lenovo.com/api";
} else {
  BaseUrl = "/api";
}
//  正式地址
let headers = {};
/*
api   : 请求的url
method: 方法 GET/POST/PUT
params: 参数
headerp: header传就是用传的不传就用自己的

*/
const Allrequest = (pdata) => {
  let { api, method, headerp, params = {} } = pdata;
  const data = method === "GET" ? "params" : "data";
  let headers = {
    "Content-Type": "application/json",
  };
  if (headerp) {
    headers = {
      ...headerp,
    };
  }
  return new Promise((resolve, reject) => {
    axios({
      url: BaseUrl + api,
      method,
      [data]: params,
      withCredentials: true,
      headers,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// 问题设置为已读
const setRead = (data) => {
  return axios({
    url: BaseUrl + `/store/question/setRead`,
    method: "get",
    withCredentials: true,
    headers: headers,
    params: {
      id: data,
    },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

// 获取热门问题榜   热门问题 和未读问题
const findAll = (data) => {
  return axios({
    url: BaseUrl + `/store/question/findAll`,
    method: "get",
    withCredentials: true,
    headers: headers,
    params: {
      ...data,
    },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

// 模糊搜索问题
const findByQuestionPageable = (data) => {
  return axios({
    url: BaseUrl + `/store/question/findByQuestionPageable`,
    method: "get",
    withCredentials: true,
    headers: headers,
    params: {
      isHot: true,
      page: data.page,
      size: data.size,
      question: data.question,
      type: 3,
      tagId: data.tagId ? data.tagId : "",
    },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

// 获取所有标签
const AllTag = () => {
  return axios({
    url: BaseUrl + `/store/tag/findAll`,
    method: "get",
    withCredentials: true,
    headers: headers,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

// 首页获取所有问题
const Allqustion = (data) => {
  return axios({
    url: BaseUrl + `/store/question/findAllPageable`,
    method: "get",
    withCredentials: true,
    headers: headers,
    params: {
      ...data,
    },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

// 获取当前解忧人组id
const GetGroupId = () => {
  return axios({
    url: BaseUrl + `/store/group/getCurrentUserGroupCli`,
    method: "get",
    withCredentials: true,
    headers: headers,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
// 创建问题
const Myask = (data) => {
  let params = {
    question: data.question, //(必填)
    userId: getCookie("userId"), //(必填)
  };
  if (data.alias) {
    params = { ...params, alias: data.alias }; //(选填)
  }
  return axios({
    url: BaseUrl + `/store/question/create`,
    method: "post",
    withCredentials: true,
    headers: headers,
    params: params,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
// 解忧人列表
const PeoplefindAllPageable = (data) => {
  return axios({
    url: BaseUrl + `/store/group/findAllPageable`,
    method: "get",
    withCredentials: true,
    headers: headers,
    params: {
      page: data.page,
      size: data.size,
    },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

// 单个解忧人 PeoplefindOne
const PeoplefindOne = () => {
  return axios({
    url: BaseUrl + `/store/group/findById`,
    method: "get",
    withCredentials: true,
    headers: headers,
    params: {
      id: 0,
    },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

// 登录
const userlogin = () => {
  return axios({
    url: BaseUrl + `/store/user/login`,
    method: "get",
    withCredentials: true,
    headers: headers,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

//注册
const userRregister = (params) => {
  return axios({
    url: BaseUrl + `/store/user/register`,
    method: "get",
    withCredentials: true,
    headers: headers,
    params: {
      ...params,
    },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

// 数据统计
const browlog = () => {
  return axios({
    url: BaseUrl + "/store/browse/log",
    method: "post",
    withCredentials: true,
    headers: headers,
    params: {
      itcode: getCookie("uid"),
    },
  })
    .then((res) => {
      sessionStorage.setItem("browlog", true);
      if (res.data.msg === "success") {
        sessionStorage.setItem("browlog", true);
      }
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

// 专家指南-列表
const guideList = (data) => {
  return axios({
    url: BaseUrl + "/store/experts/storeExpertList",
    method: "post",
    withCredentials: true,
    headers: headers,
    data: data,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
// 专家指南-详情
const guideDetail = (data) => {
  return axios({
    url: BaseUrl + "/store/experts/storeExpertDetail",
    method: "post",
    withCredentials: true,
    headers: headers,
    data: data,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

// 获取当前马甲
const queryAlias = () => {
  let data = {
    api: "/store/question/queryAlias",
    method: "GET",
    params: {
      userId: getCookie("userId"),
    },
    headerp: headers
  };
  return new Promise((resolve, reject) => {
    Allrequest(data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
const findAllQuestionByGroupId = () => {
  let data = {
    api: "/store/question/findAllQuestionByGroupId",
    method: "GET",
    params: {
      page: 0,
      size: 100,
      groupId: JSON.parse(sessionStorage.getItem("groupId")),
    },
    headerp: headers
  };
  return new Promise((resolve, reject) => {
    Allrequest(data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 回答问题
const giveAnswer = (data) => {
  return axios({
    url: BaseUrl + "/store/question/giveAnswer",
    method: "post",
    withCredentials: true,
    headers: headers,
    data: data,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
// 设置title
const editTitle = (data) => {
  return axios({
    url: BaseUrl + "/store/question/editTitleCli",
    method: "post",
    withCredentials: true,
    headers: headers,
    data: data,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
// 给问题点赞
const likeQuestion = (data) => {
  return axios({
    url: BaseUrl + "/store/question/setQuestionLike",
    method: "get",
    withCredentials: true,
    headers: headers,
    params: { ...data },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
// 给问题的回答点赞
const likeAnswer = (data) => {
  return axios({
    url: BaseUrl + "/store/question/setAnswerLike",
    method: "get",
    withCredentials: true,
    headers: headers,
    params: { ...data },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
// 给其他人回复点赞
const likeOthers = (data) => {
  return axios({
    url: BaseUrl + "/store/question/setQuestionLikeReply",
    method: "get",
    withCredentials: true,
    headers: headers,
    params: { ...data },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
// 匿名回复
const getreply = (data) => {
  return axios({
    url: BaseUrl + "/store/question/reply",
    method: "get",
    withCredentials: true,
    headers: headers,
    params: { ...data },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
// 查询问题详情
const getDetail = (data) => {
  return axios({
    url: BaseUrl + "/store/question/findQuestionByd",
    method: "get",
    withCredentials: true,
    headers: headers,
    params: { ...data },
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
// 更新问题

const editAnswer = (data) => {
  return axios({
    url: BaseUrl + "/store/question/editAnswerForClient",
    method: "post",
    withCredentials: true,
    headers: headers,
    data: data,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
export {
  browlog,
  userlogin,
  userRregister,
  PeoplefindAllPageable,
  PeoplefindOne,
  Myask,
  Allqustion,
  AllTag,
  setRead,
  findAll,
  findByQuestionPageable,
  Allrequest,
  GetGroupId,
  guideList,
  guideDetail,
  queryAlias,
  findAllQuestionByGroupId,
  giveAnswer,
  editTitle,
  likeQuestion,
  likeAnswer,
  likeOthers,
  getreply,
  getDetail,
  editAnswer,
};
